export default "__VITE_ASSET__hlyNwR83__"